import { render, staticRenderFns } from "./spinner.vue?vue&type=template&id=710c5762&"
import script from "./spinner.vue?vue&type=script&lang=js&"
export * from "./spinner.vue?vue&type=script&lang=js&"
import style0 from "./spinner.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports